import { CSSProperties, ReactNode } from "react";

type Props = {
  children: ReactNode;
  style?: CSSProperties;
  padded?: boolean;
};

export function Card({ children, style, padded = true }: Props) {
  return (
    <div
      style={{
        background: "var(--bg-card)",
        borderRadius: 12,
        boxShadow: "var(--sh-1)",
        padding: padded ? "var(--pad-card)" : 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
